<template>
	<div class="content">
		<div class="home-us">
			<img src="../assets/home-image/posionbackimg.png" />
		</div>
		<div class="home-us-text">
			<p>互联网+教育 Internet+ Education</p>
		</div>
		<div class="home-us-text-two">
			<p>专业高效 让互联网推动教育行业创新发展</p>
		</div>
		<el-carousel indicator-position="outside">
			<el-carousel-item v-for="item in bannerlist" :key="item.id" class="banner-image-item">
				<img :src="item.ulr" />
			</el-carousel-item>
		</el-carousel>
		<div class="banner-smallbox">
		</div>
	</div>
</template>

<script>
	export default {
		name: 'BannerImage',
		data() {
			return {
				bannerlist: [
					/* { id: '01', ulr: require('../assets/home-image/neonbrand-1-aA2Fadydc-unsplash.jpg') }, */
					{
						id: '02',
						ulr: require('../assets/home-image/bannerImage.png')
					}
				],
        bannersList:[],
			}
		}
	}
</script>

<style>
	/* banner start */
	.home-us {
		width: 591px;
		height: 486px;
		position: absolute;
		top: 369px;
		left: 1300px;
		z-index: 999
	}

	.home-us img {
		width: 100%;
		height: 100%
	}

	.home-us-text {
		width: 630px;
		height: 59px;
		font-size: 40px;
		font-family: Source Han Sans SC;
		font-weight: 400;
		line-height: 59px;
		color: #39ab6d;
		opacity: 1;
		position: absolute;
		top: 830px;
		left: 1192px;
		z-index: 999
	}

	.home-us-text p {
		width: 100%;
		height: 59px
	}

	.home-us-text-two {
		width: 486px;
		height: 38px;
		font-size: 26px;
		font-family: Source Han Sans SC;
		font-weight: 400;
		line-height: 120px;
		color: #333;
		opacity: 1;
		position: absolute;
		top: 867px;
		left: 1195px;
		z-index: 999
	}

	.home-us-text-two p {
		width: 100%;
		height: 38px
	}

	.el-carousel {
		min-width: 1894px
	}

	.banner-image-item,
	.el-carousel {
		width: 100%;
		height: 60.25rem !important
	}

	.banner-image-item {
		z-index: 9999
	}

	.banner-image-item img {
		display: inline-block;
		max-width: 100%;
		height: auto;
		width: 100% !important;
		background-size: 100% 100% !important
	}

	.el-carousel__container {
		height: 100% !important
	}

	.banner-smallbox {
		position: absolute;
		top: 18.125rem;
		right: 0
	}

	@media screen and (max-width: 100rem) {
		.el-carousel {
			min-width: 100%;
			width: 100%
		}

		.banner-image-item {
			width: 100%;
			height: 30rem;
			z-index: 9999
		}

		.el-carousel__container {
			height: 90% !important
		}

		.home-us {
			width: 591px;
			height: 486px;
			position: absolute;
			top: 369px;
			left: 1300px;
			z-index: 999
		}

		.home-us img {
			width: 100%;
			height: 100%
		}

		.home-us-text {
			width: 630px;
			height: 59px;
			font-size: 40px;
			font-family: Source Han Sans SC;
			font-weight: 400;
			line-height: 59px;
			color: #39ab6d;
			opacity: 1;
			position: absolute;
			top: 830px;
			left: 1192px;
			z-index: 999
		}

		.home-us-text p {
			width: 100%;
			height: 59px
		}

		.home-us-text-two {
			width: 486px;
			height: 38px;
			font-size: 26px;
			font-family: Source Han Sans SC;
			font-weight: 400;
			line-height: 120px;
			color: #333;
			opacity: 1;
			position: absolute;
			top: 867px;
			left: 1195px;
			z-index: 999
		}

		.home-us-text-two p {
			width: 100%;
			height: 59px
		}
	}

	@media screen and (max-width: 62rem) {
		.el-carousel {
			width: 100%;
			min-width: 100%;
			height: 31.25rem !important
		}

		.banner-image-item {
			height: 32.25rem !important;
			width: 100%;
			z-index: 9999
		}

		.el-carousel__container {
			height: 55% !important
		}

		.home-us {
			width: 32%;
			height: 200px;
			height: auto;
			position: absolute;
			top: 226px;
			left: 627px;
			z-index: 999;
			display: none
		}

		.home-us img {
			width: 100%;
			height: auto
		}

		.home-us-text {
			width: 44%;
			height: 59px;
			font-size: 25px;
			font-family: Source Han Sans SC;
			font-weight: 400;
			line-height: 59px;
			color: #39ab6d;
			opacity: 1;
			position: absolute;
			top: 449px;
			left: 516px;
			z-index: 999;
			display: none
		}

		.home-us-text p {
			width: 100%;
			height: 59px
		}

		.home-us-text-two {
			width: 393px;
			height: 38px;
			font-size: 19px;
			font-family: Source Han Sans SC;
			font-weight: 400;
			line-height: 120px;
			color: #333;
			opacity: 1;
			position: absolute;
			top: 457px;
			left: 520px;
			z-index: 999;
			display: none
		}
	}
	@media screen and (max-width: 48rem) {
		.el-carousel {
			width: 100%;
			min-width: 100%
		}

		.banner-image-item,
		.el-carousel {
			height: 14.25rem !important
		}

		.banner-image-item {
			width: 100%;
			z-index: 9999
		}

		.el-carousel__container {
			height: 90% !important
		}
	}
	/* banner end */
</style>



// WEBPACK FOOTER //
// src/components/Bannar.vue